import { properCase } from '@petconsole/pure-base';
import { EntityName } from '../types';

const ourEntityNameToType = (entityName: EntityName) => properCase(entityName) as EntityName;

export default ourEntityNameToType;
